<template>
  <div class="page">
    <div class="container">
      <div class="page__inner">
        <p class="page__counter">05</p>
        <h1 class="subtitle subtitle_red page__subtitle" style="margin-bottom: 27px;">Design and production of narratives and events</h1>
<!--        <p class="lead page__lead">Мы предлагаем нелинейные подходы даже если задача кажется стандартной</p>-->
      </div>
    </div>

    <design-background />

    <page-footer
      :prev="{ name: 'anticrisis-en' }"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import DesignBackground from '@/components/servicesSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '@/views/mixins/route'

export default {
  name: 'design',
  mixins: [RouteMixin],
  components: {
    DesignBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.design-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__counter', 0.3, { y: '-20px', opacity: 0 }))
      .add(TweenMax.from('.page__subtitle', 0.3, { y: '-10px', opacity: 0 }))
      .add(TweenMax.from('.page__lead', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__subtitle', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__counter', 0.3, { y: '20px', opacity: 0 }))
      .add(TweenMax.to('.page__lead', 0.3, { y: '20px', opacity: 0 }))
      .add(TweenMax.to('.design-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
